import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from 'react-bootstrap/lib/Checkbox'

function ToggleAll(props) {
  const { mode, onSelect, onDeSelect } = props
  const checked = mode === 'all'

  function handleOnClick() {
    if (mode === 'all' || mode === 'some') {
      onDeSelect()
    } else {
      onSelect()
    }
  }

  return (
    <Checkbox
      onClick={handleOnClick}
      readOnly
      checked={checked}
      inputRef={(ref) => {
        if (ref) ref.indeterminate = mode === 'some'
      }}>
      {props.children}
    </Checkbox>
  )
}

ToggleAll.propTypes = {
  mode: PropTypes.oneOf(['all', 'none', 'some']).isRequired,
  onSelect: PropTypes.func,
  onDeSelect: PropTypes.func,
}

ToggleAll.defaultProps = {
  onSelect: () => {},
  onDeSelect: () => {},
}

export default ToggleAll
